import { Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'app-display-field',
  templateUrl: './display-field.component.html',
  styleUrls: ['./display-field.component.scss']
})
export class DisplayFieldComponent {

  @Input() label;
  @Input() value;
  @Input() valueColor: 'red' | 'green' | 'black' | 'yellow' | 'gray' = 'black';
  @Input() translationKey;

  @HostBinding('class') get class() {
    return this.valueColor;
  }

}
